var fullNavigation = [
  { name: "projects", title: "Projects", icon: "icon icon-file", credential: "projects.list" },
  { name: "lead_masks", title: "Lead sheets", icon: 'icon icon-layout1', access: "allowed_custom_leadsheets", credential: "lead_masks.list" },
  { name: "users", title: "Manage users", icon: "icon icon-users", credential: "users.list" },
  { name: "organizations", title: "Manage organizations", icon: "icon icon-globe1", credential: "organizations.list" },
  { name: "content_manager", title: "Content Manager", icon: 'icon icon-grid1', class: "content_manager", credential: "external_forms.list"},
  { name: "external_forms", title: "Forms", credential: "external_forms.list", class: "nested", access: "allowed_forms" },
  { name: "projects_synchronize", title: "", credential: "projects.synchronize", class: "sync-item", icon: "icon icon-refresh-ccw1", access: "allowed_crm" },
]

var apiUrl  = process.env.API_URL
//     Please don't remove these:
//     apiUrl  = "https://api-test.fanomena.io/"
//     apiUrl  = "https://api-staging.fanomena.io/"
//     apiUrl  = "https://api.fanomena.io/"

// Default fallback logic when API_URL was not specified explicitly
if (!apiUrl) {
  if (process.env.NODE_ENV === "production") {
    apiUrl  = "/api/"
  } else {
    apiUrl  = "http://localhost:3000/"
  }
}

var formUrl = process.env.FORM_URL
// Default fallback logic when FORM_URL was not specified explicitly
if (!formUrl) {
  if (process.env.NODE_ENV === "production") {
    formUrl  = "/hileadzzform/"
  } else {
    formUrl  = "http://localhost:4567/"
  }
}

export {
  fullNavigation,
  apiUrl,
  formUrl
}



// WEBPACK FOOTER //
// ./src/config/config.js